export const STATS_GET_ONBOARDING_REQUESTING =
  "STATS_GET_ONBOARDING_REQUESTING";
export const STATS_GET_ONBOARDING_SUCCESS = "STATS_GET_ONBOARDING_SUCCESS";
export const STATS_GET_ONBOARDING_ERROR = "STATS_GET_ONBOARDING_ERROR";
export const STATS_UPDATE = "STATS_UPDATE";
